import { Component } from 'react';
import { apiGetP } from '../../GanjiTools';
import { TreeList, Column as TColumn } from 'devextreme-react/tree-list';

class TablesTree extends Component {
    state = {
        focusedTable: {},
        tables: [], tablesTree: [], schemas: [],
        tablesKey: 1,
    }

    loadTablesDataP = () => new Promise((resolve, reject) => {
        let url = `/api/dyna/dbdata?includeColumns=n&forceLoadTablesList=y`;

        apiGetP(url)
            .catch(reject)
            .then(res => {
                let { tableProps, schemas } = res ?? { tableProps: [], schemas: [] };
                let tables = tableProps.filter(x => x.schema !== 'Uni');
                schemas = schemas.filter(x => x !== 'Uni');
                let tablesTree = [];
                let idCounter = 1;
                tablesTree = schemas.map(x => ({ id: ++idCounter, name: x, parent: null, icon: 'folder' }));
                let tablesBranches = tables.map(x => ({ id: ++idCounter, name: x.tableName, parent: x.schema, icon: 'detailslayout' }));
                tablesTree = [...tablesTree, ...tablesBranches].sort((a, b) => a.name < b.name ? -1 : a.name === b.name ? 0 : 1)

                resolve({ tables, tablesTree, schemas });
            });
    })

    loadTableData = table => {
        let tableName = table?.tableName?.toLowerCase?.() ?? '';

        if (!(tableName?.length > 0)) {
            this.props.onFocusedTableChanged?.({});
            return;
        }

        if (this.props.formBased) {
            apiGetP(`/api/form/formsOfTable/${tableName}`)
                .catch(err => {
                    window.notif(err);
                    this.props.onFocusedTableChanged?.({});
                })
                .then(forms => {
                    //this.state.focusedTable = table;
                    forms ??= [];
                    this.props.onFocusedTableChanged?.({ tableName: table.tableName, forms });
                });

            return;
        }

        apiGetP(`/api/dyna/dbdata/${tableName.toLowerCase()}?includeColumns=s&forceLoadTablesList=n`)
            .catch(err => {
                window.notif(err);
                this.props.onFocusedTableChanged?.({});
            })
            .then(res => {
                let { tableProps, parentColName, groupColName } = res ?? { tableProps: [], parentColName: '', groupColName: '' };

                let columns = tableProps.find(x => x.tableName?.toLowerCase?.() === tableName)
                    ?.columns?.filter(x => x.name?.toLowerCase() !== 'id')?.map(x => ({ ...x, foreignKey: x.foreignKey?.referencedTable })) ?? [];

                this.props.onFocusedTableChanged?.({ tableName: table.tableName, parentColName, groupColName, columns });
            });
    }

    componentDidMount() {
        this.loadTablesDataP()
            .catch(window.notif)
            .then(res => {
                // this.state.focusedTable = this.props.focusedTableName?.length > 0
                //     ? res.tables.find(x => x.tableName?.toLowerCase() === this.props.focusedTableName.toLowerCase())
                //     : undefined;

                this.setState({ ...res }, () => {
                    //this.focusedTable = this.props.focusedTableName?.length > 0 ? this.state.tables.find(x => x.tableName === this.props.focusedTableName) : {}; // ??
                    this.props.onTablesDataLoaded?.(res?.tables, res?.schemas);
                });
            });
    }

    renderTablesTreeCell = c => {
        let { name, icon, parent } = c?.data ?? { name: '', icon: '', parent: null };
        let rtl = this.props.rtlEnabled === true;
        return (
            <div style={{
                fontWeight: name === this.state.focusedTable?.tableName ? 'bold' : 'normal',
                direction: rtl ? 'rtl' : 'ltr',
                paddingLeft: parent ? '0.5rem' : '0'
            }}
            >
                {rtl && <span style={{ marginRight: '5px' }}>{name}</span>}
                <span className={'dx-icon-' + icon}></span>
                {!rtl && <span style={{ marginLeft: '5px' }}>{name}</span>}
                {/* {name === this.state.focusedTable?.tableName && <span className='dx-icon-arrowright' style={{ marginLeft: '1rem' }}></span>} */}
            </div>
        )
    }

    render() {

        return (
            <>
                <TreeList rtlEnabled={this.props.rtlEnabled === true} autoExpandAll keyExpr='name'
                    expandedRowKeys={this.state.tablesTree?.filter(x => !x.parent)?.map(x => x.name)}
                    dataSource={this.state.tablesTree} parentIdExpr='parent'
                    width={this.props.width ?? '200px'} height={this.props.height ?? 'calc(100vh - 10rem)'}
                    focusedRowEnabled hoverStateEnabled showColumnHeaders={false}
                    //focusedRowKey={this.props.focusedTableName} //this.props.focusedTableName/* 
                    focusedRowKey={this.props.focusedTableName}
                    onFocusedRowChanged={e => {
                        let table = e.row?.data;
                        let focusedTable = table?.parent && table.name?.length > 0
                            ? this.state.tables.find(x => x.tableName?.toLowerCase() === table.name?.toLowerCase())
                            : undefined;
                        this.focusedTableName = focusedTable?.tableName;
                        this.loadTableData(focusedTable);
                    }}
                >
                    <TColumn dataField='name' cellRender={this.renderTablesTreeCell} />
                </TreeList>
            </>
        );
    }
}

export default TablesTree;